import { FC, useState } from 'react';
import { useAppSelector } from '../hooks/redux-hooks';
import Tooltip from './common/Tooltip';

const MsgOptions: FC<{
  message: string;
  msgId?: string;
  isGoodResponse?: boolean | null;
  isLastMsg?: boolean;
}> = ({ message }) => {
  const {  chatLoading } = useAppSelector((state) => state.chat);
  const [copied, setCopied] = useState(false);

  const copyTextToClipboard = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
    if (navigator && 'clipboard' in navigator) {
      return navigator.clipboard.writeText(message);
    } else {
      return document.execCommand('copy', true, message);
    }
  };

  // const likeDislike = async (value: boolean) => {
  //   if (!msgId) return;
  //   try {
  //     const response = await ChatUtilsService.likeDislikeAnswer(
  //       value,
  //       msgId,
  //       selectedAgent ? true : false
  //     );
  //     if (response.data.data?.qaDirectory.msgId) {
  //       setQaDirectoryResponse(response.data.data?.qaDirectory);
  //       if (!compareModel) {
  //         const userChat: ChatMsgProps[] = JSON.parse(
  //           getItem('chatData') || '[]'
  //         );
  //         const updatedArray = userChat.map((item, index) =>
  //           item.msgId === msgId && item.sender === SenderType.ASSISTANT
  //             ? {
  //                 ...item,
  //                 isGoodResponse:
  //                   response.data.data?.qaDirectory.isGoodResponse,
  //               }
  //             : item
  //         );
  //         setItem('chatData', JSON.stringify(updatedArray));
  //         setChatData(updatedArray);
  //       }
  //     }
  //   } catch (err) {
  //     console.log('Error: ', err);
  //   }
  // };

  // const summarize = () => {
  //   const msgId = uuid4();
  //   if (compareModel) {
  //     setCompareData([
  //       ...compareData,
  //       {
  //         msg: 'Summarize this.',
  //         model: compareModel.aiModelName,
  //         sender: SenderType.USER,
  //         msgId,
  //         chatId: userChatId,
  //       },
  //     ]);
  //   } else {
  //     setChatData([
  //       ...chatData,
  //       {
  //         msg: 'Summarize this.',
  //         model: currentAIModel?.aiModelName ?? '',
  //         sender: SenderType.USER,
  //         msgId,
  //         chatId: userChatId,
  //       },
  //     ]);
  //   }
  //   setSessionStorageData('Summarize this.', SenderType.USER, msgId);
  // };

  // const isResponseGood =
  //   (qaDirectoryResponse?.msgId === msgId &&
  //     qaDirectoryResponse?.isGoodResponse) ||
  //   isGoodResponse;

  return (
    <div className="pt-3 w-full flex flex-col">
      {!chatLoading && (
        <div className="flex justify-between items-center w-full transition">
          <div className="flex items-center">
            {/* <Tooltip
                  content={isGoodResponse !== true ? 'Good Response' : ''}
                  direction="top"
                >
                  <i
                    className={`
                ${
                  isResponseGood
                    ? 'icon-thumbsup-2 cursor-default pointer-events-none'
                    : 'icon-thumbsup-2 cursor-pointer'
                } text-2xl mr-3 hover:text-black dark:hover:text-white
              `}
                    onClick={() => likeDislike(true)}
                  ></i>
                </Tooltip> */}
            {/* <Tooltip
                  content={isGoodResponse !== false ? 'Bad Response' : ''}
                  direction="top"
                >
                  <i
                    className={`
                ${
                  isResponseGood === false
                    ? 'icon-thumbs-down-fill cursor-default pointer-events-none'
                    : 'icon-thumbs-down text-[#a1a1a1] cursor-pointer'
                } text-lg sm:text-xl mr-3 hover:text-black dark:hover:text-white
              `}
                    onClick={() => likeDislike(false)}
                  ></i>
                </Tooltip> */}
            <Tooltip content={copied ? '' : 'Copy'} direction="top">
              <i
                className="icon-copy sm:text-xl mr-3 cursor-pointer hover:text-black dark:hover:text-white"
                onClick={() => copyTextToClipboard()}
              ></i>
            </Tooltip>
            {/* {!isImage && isLastMsg && (
              <Tooltip content="Summarize" direction="top">
                <i
                  className="icon-summarize-alt text-2xl mr-3 cursor-pointer hover:text-black dark:hover:text-white"
                  onClick={() => summarize()}
                ></i>
              </Tooltip>
            )} */}
            {/* {agentInfo?._id && (
              <Tooltip content="Share Chat" direction="top">
                <i
                  className="icon-share-2 text-2xl mr-3 cursor-pointer hover:text-black dark:hover:text-white"
                  onClick={() => setOpenShareModal(true)}
                ></i>
              </Tooltip>
            )} */}
          </div>
        </div>
      )}
      {/* {openShareModal && (
        <ShareModal
          onClose={() => {
            setOpenShareModal(false);
          }}
          chatLink={`${process.env.NEXT_PUBLIC_APP_URL}/chat?${
            selectedAgent ? `threadLink=${threadId}` : `chatLink=${userChatId}`
          }asdfgh897608zxcvbn${userInfo?._id}`}
        />
      )} */}
    </div>
  );
};

export default MsgOptions;
